var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartyWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.57117 14.5L9.4657 18.4141M18.9995 3.60975C17.4043 3.59505 16.6657 4.33233 16.4235 5.07743C16.2102 5.73354 16.4051 7.07735 15.8959 8.0727C15.409 9.02443 14.1203 9.5617 12.657 9.60697M19.9999 7.6104L20.0099 7.61049M18.9999 15.96L19.0099 15.9601M6.99988 3.94926L7.00988 3.94936M18.9999 11.1094C17.4999 11.1094 16.4999 11.6094 15.5948 12.5447M10.2376 7.18796C10.9999 6.10991 11.4999 5.10991 11.0081 3.52734M3.53564 20.4645L7.07117 9.85791L14.1423 16.929L3.53564 20.4645Z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartyWhite);
export default __webpack_public_path__ + "static/media/party-white.854e7610ecd0de796e4f3ebffc6ca5ef.svg";
export { ForwardRef as ReactComponent };